<!--
  - 代码编辑器 文件列表
-->

<template>
	<div class="filelist" :style="{width: width, height: height}">
		<div class="list">
			<ul :style="{height: height}">
				<li v-for="(item, index) in data" @click="click(item)">
					<div class="item">
						<div class="title">
							{{item.code_id}}. {{item.title}}
						</div>
						<div class="desc">{{item.description || '无描述'}}</div>
						<div class="tag">
							<span class="tag-item tag-primary">{{item.language}}</span>
							<span class="tag-item tag-success" v-if="item.is_public === 1">公开</span>
							<span class="tag-item tag-warning" v-else>私有</span>
						</div>
					</div>
				</li>
				<li class="more" @click="more" v-show="more_show">
					查看更多
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'filelist',
		data(){
			return {}
		},
		props: {
			width: {
				type: String,
				default: '200px',
			},
			height: {
				type: String,
				default: '300px',
			},
			data: {
				type: Array,
				default: function(){
					return [];
				},
			},
			more_show: {
				type: Boolean,
				default: false,
			},
		},
		created(){
			this.$nextTick(function(){
			})
		},
		methods: {
			click(item){
				this.$emit('click', item)
			},
			more(){
				this.$emit('more');
			},
		}
	}
</script>

<style scoped lang="less">
	@filelist_background_color: #282823;
	@filelist_font_color: #fff;
	@filelist_main_border_color: #000;
	@filelist_item_border_color: #666;
	@filelist_item_font_color: #ccc;
	.filelist {
		background: @filelist_background_color;
		color: @filelist_font_color;
		border-right: 3px solid @filelist_main_border_color;
		
		ul {
			padding: 10px 0px;
			overflow-y: auto;
			
			li {
				border-bottom: 1px solid #333;
			}
			
			li:hover {
				cursor: pointer;
				background: #595959;
				
				.title {
					text-decoration: underline;
				}
			}
			
			.more {
				text-align: center;
				color: #aaa;
			}
			
			.more:hover {
				cursor: pointer;
			}
			
			.tag {
				margin-top: 2px;

			}
		}
	}
	
	.item {
		padding: 5px 10px;
		
		.title {
			font-size: 15px;
			font-weight: 500;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		
		.desc {
			font-size: 10px;
			color: @filelist_item_font_color;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
</style>

